import { Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

export default function ModifiedTag() {
  return (
    <Text color="neutral.300" paddingX={0.5} height="20px" marginLeft="auto" backgroundColor="neutral.750">
      <FormattedMessage id="global.modified" />
    </Text>
  );
}
